import React from "react";

/**
 * Wraps main page content so it aligns with the PublicHeader:
 * left edge with logo, right edge with "Free 5-Day Trial" CTA.
 * Uses the same container as the header: max-w-7xl mx-auto px-4 sm:px-6 lg:px-8.
 */
const PublicContentWrap = ({ children, className = "", as: Component = "div", ...props }) => {
  return (
    <Component
      className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full ${className}`.trim()}
      {...props}
    >
      {children}
    </Component>
  );
};

export default PublicContentWrap;
